module.exports = __webpack_public_path__ + "img/zhipinban5.6b30dc23.jpg";